<template>
  <v-layout row>
    SCPs For Clipboard
  </v-layout>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import myMixins from '../mixins/myMixins'
export default {
  data () {
    return {
    }
  },
  mixins: [myMixins],
  methods: {
  },
  created () {
    let startDate = moment()
    //    let startDate = moment("2019-08-20")
    let endDate = moment(startDate).add(1, 'days')
    let url = process.env.VUE_APP_BACKEND + 'scps?startDate=' + startDate.format('YYYY-MM-DD') +
         '&endDate=' + endDate.format('YYYY-MM-DD') + '&pdf=true'
    window.open(
      url,
      '_blank' // <- This is what makes it open in a new window.
    )
  },
  computed: {
    vineyards () {
      return this.$store.state.vineyards
    },
    varietals () {
      return this.$store.state.varietals
    }
  }
}
</script>

<style>
.largeSelect {
    width: 300px
  }
</style>
